/** @module csi/widget/_svg/Pdf */
define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory"
], function(Button, _Plugin, PluginFactory) {

	return PluginFactory.declare([Button, _Plugin], {
		iconClass: "far fa-fw fa-file-pdf",
		pluginName: "pdf",
		title: "ViewPdf_TT",

		/**
		 * Only show plugin when not in edit mode
		 * @return {boolean}
		 */
		canShowPlugin: function() {
			return !this.editor.editMode;
		},

		/**
		 * Regenerate snapshots if any are missing and export view to PDF.
		 */
		onClick: function() {
			const {view} = this.editor;
			if (view.isMissingSnapshots()) {
				view.regenerateSnapshots(() => view.printToPdf());
			} else {
				view.printToPdf();
			}
		}
	});
});